import { PartialIntervalCalculator } from './PartialIntervalCalculator';
export class PartialIntervalManager {
    constructor() {
        this.minColor = '';
        this.midColor = '';
        this.maxColor = '';
        this.stepMultiplier = 1.0;
        this.partialIntervals = [];
    }
    get(index) {
        return this.partialIntervals[index];
    }
    get count() {
        return this.partialIntervals.length;
    }
    setStepMultiplier(stepMultiplier) {
        this.stepMultiplier = stepMultiplier;
    }
    populateIntervals() {
        this.partialIntervals = PartialIntervalCalculator.recalculate(this.minColor, this.midColor, this.maxColor, this.stepMultiplier);
    }
    applyColors(minColor, midColor, maxColor) {
        this.minColor = minColor;
        this.midColor = midColor;
        this.maxColor = maxColor;
    }
    getStepMultiplier() {
        return this.stepMultiplier;
    }
    getIntervals() {
        return this.partialIntervals;
    }
    getSelectedIntervals() {
        return this.partialIntervals.filter((x) => x.IsSelected);
    }
    getDefaultColor() {
        return this.midColor;
    }
}
